import {rootLogger} from '../logger';
import {useSettingsMenuActions} from '../plugins/hooks/useSettingsMenuAction';
import {useInfinityContext} from '../hooks/useInfinityContext';

import {useMe} from './useMe';
import {useFeedback} from './useFeedback';

const downloadLogWithName = () => rootLogger.downloadLog();

export const useUserMenuContent = ({isInMeeting}: {isInMeeting: boolean}) => {
    const infinity = useInfinityContext();
    const me = useMe(infinity.getMe);
    const meeting = infinity.getMeeting();
    const isDirectMedia = meeting.getConferenceFeatureFlags()?.isDirectMedia;
    const canControl = me?.canControl;
    const canChangeLayout = me?.canChangeLayout;

    const {isFeedbackEnabled, openFeedbackForm} = useFeedback();

    const pluginActions = useSettingsMenuActions(me, isInMeeting);

    return {
        downloadLogWithName,
        canControl,
        canChangeLayout,
        isDirectMedia,
        isFeedbackEnabled,
        openFeedbackForm,
        pluginActions,
    };
};
